// ---------------------------------------------- modules import
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/messaging";
import { ReactReduxFirebaseConfig } from "react-redux-firebase";

import fbConfig from "./fbConfig";

// ---------------------------------------------- initialize firebase instance
firebase.initializeApp(fbConfig);

// ---------------------------------------------- react-redux-firebase config
export const rrfConfig: Partial<ReactReduxFirebaseConfig> = {
  userProfile: "users",
  useFirestoreForProfile: true
};

export const messaging = firebase.messaging()
export const firestore = firebase.firestore()


messaging.requestPermission()
  .then(() => {
    console.log("console have permission");
    return messaging.getToken();
  })
  .then(token => {
    const subNewPost = firebase.functions().httpsCallable('subNewPost');
    subNewPost(token)
      .catch(err => console.log("error subscribe :", err))
  })
  .catch(err => { console.log("error occured", err) })

export const vapidkey = messaging.usePublicVapidKey(
  // Project Settings => Cloud Messaging => Web Push certificates
  "BFK5ITnjyfpDoQ87ugvh1r7XlqCkuQcQ8hb5znCgSrz6E9bL0kN067ATyOXup3Bvgt0O6R-37WSgeZ_5pW2rHmY"
);


export default firebase;
